import React, {useState, useEffect, useMemo} from 'react';
import { Alert, Modal, Platform, ScrollView, Share, TouchableOpacity, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import IcomoonIcon from '../../../../components/IcomoonIcon';
import { Illustration } from '../../../../components/Illustration';
import { Icon } from '../../../../components/Icon';
import IconButton from '../../../../components/IconButton';
import api from '../../../../utils/api';
import { useToast } from 'react-native-toast-notifications';


import dayjs from 'dayjs'
import 'dayjs/locale/es'
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Image } from 'expo-image';
dayjs.locale('es')

import { Directory, File, Paths } from 'expo-file-system';

import RNShare from './RNShare';

export default function GuestPassDetailModal({ onRequestClose, visible, community, unitId, guestPass, onDeleted }) {
  const insets = useSafeAreaInsets()
  const [isDeleting, setIsDeleting] = useState(false);
  const toast = useToast();

  useEffect(() => {

  }, [visible]);

  const deleteGuestPass = () => {
    setIsDeleting(true);
    api.delete(`/communities/${community}/units/${unitId}/entry-passes/${guestPass.uuid}`)
      .then(() => {
        toast.show("Pase eliminado");
        onDeleted?.();
      })
      .catch((error) => {
        alert(error.response?.data?.message || "Error al eliminar");
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  const confirmDeletion = () => {
    if (Platform.OS === "web") {
      if (confirm(`¿Eliminar pase de ${guestPass.guest_name}?\nEsta acción no podrá deshacerse`)) {
        deleteGuestPass();
      }
    } else {
      Alert.alert(
        '¿Eliminar pase?',
        `El pase de ${guestPass.guest_name} será eliminado y ya no podrá usarse`,
        [
          { text: 'Cancelar', style: 'cancel' },
          { text: 'Eliminar', style: 'destructive', onPress: deleteGuestPass },
        ]
      );
    }
  };

  const downloadAndShareImage = async () => {
    const { qr_code_url, message, title } = guestPass

    const imageUrl = `${qr_code_url}?format=png`

    try {
      const dir = new Directory(Paths.cache);
      const fileName = `qr_code_${Date.now()}.png`;
      const destinationFile = new File(dir, fileName);
      const file = await File.downloadFileAsync(imageUrl, destinationFile);


      const shareOptions = {
        message,
        title: "Comparte este pase",
        url: file.uri,
        type: 'image/png',
      };
      
      // console.log({ shareOptions, imageUrl })

      if(Platform.OS !== "web"){
        await RNShare.open(shareOptions);
      }
    } catch (error) {
      if (error?.message?.includes("did not share")) {
        console.warn("Compartir cancelado por el usuario.");
      } else {
        console.error('Error al compartir la imagen:', error);
        alert('Error al compartir la imagen: ' + error);
      }
    }
  };

  async function sendGuestPass() {
    const message = guestPass.message
    const title = guestPass.title


    try {
      const result = await Share.share({
        message,
        title,
      }, {
        dialogTitle: "Comparte este pase",
      });
      if (result.action === Share.sharedAction) {
        if (result.activityType) {
          // shared with activity type of result.activityType
        } else {
          // shared
        }
      } else if (result.action === Share.dismissedAction) {
        // dismissed
      }
    } catch (error: any) {
      Alert.alert(error.message);
    }
  }


  if(!guestPass) return null
  
  const entryDate = dayjs(guestPass?.data?.entry_date)
  const entryTime = guestPass?.data?.entry_time// == "all_day" ? guestPass?.data?.entry_time : dayjs(guestPass?.data?.entry_time)

  const entryDateLimit = guestPass?.data?.entry_date_limit ? dayjs(guestPass?.data?.entry_date_limit) : null
  const entryTimeLimit = guestPass?.data?.entry_time_limit// ? dayjs(guestPass?.data?.entry_time_limit) : null

  const days = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do']

  function renderDays() {
    return (
      <View style={tw`row gap-x-2`}>
        {
          guestPass.data?.valid_days?.map((valid, index) =>
            valid ? <Text key={index} style={tw`text-gray-400`}>{days[index]}</Text> : null
          )
        }
      </View>
    )
  }

  console.log({ guestPass });
  

  return (
    <Modal
      onRequestClose={onRequestClose}
      visible={!!visible}
      statusBarTranslucent={true}
      animationType='slide'
    >
      <ScrollView style={tw`px-5 flex-1 bg-primary pt-[${insets.top}px`}>
        <View style={tw`mb-4`}>
          <View style={tw`row justify-between mb-4 mt-5`}>
            <View style={tw`row`}>
              <Icon name="qr" size={40} style={tw`mr-3`} />

              <Text style={tw`text-lg font-600 text-secondary`}>Nuevo QR de invitado</Text>
            </View>

            <TouchableOpacity
              style={tw`items-center justify-center mr-2`}
              onPress={onRequestClose}
            >
              <IcomoonIcon name='close' style={tw`text-red`} size={26} />
            </TouchableOpacity>
          </View>
        </View>


        <View style={tw`bg-primary-100 border border-gray-200 px-3 py-5 rounded-xl items-center`}>
          <Text style={tw`px-3 text-lg font-500 text-primary-800 text-center`}>Invitación creada</Text>

          {/* Image */}
          <View style={tw`my-8 p-4 bg-white rounded-lg`}>
            <Image source={guestPass.qr_code_url} style={tw`h-40 w-40`} />
          </View>

          {/* Código alfanumérico */}
          {
            guestPass.short_code &&
              <TouchableOpacity style={tw`bg-white w-90% rounded-xl items-center border border-primary-200 py-4 mb-6`}>
                <Text style={tw`text-3xl text-primary-800 font-500 tracking-[12px]`}>{guestPass.short_code}</Text>
              </TouchableOpacity>
          }

          <Text style={tw`text-secondary text-xl font-600 `}>{guestPass.guest_name}</Text>
          {/* <Text style={tw`text-gray-400 py-4`}>{guestPass.url}</Text> */}
          {/* <Text style={tw`text-gray-400 text-lg`}><Text style={tw`font-500 `}>{entryDateStr.format('ddd D-MM-YYYY')}</Text> {entryTimeStr.format('hh:mm a')}</Text> */}

          <View style={tw`mt-3 items-center`}>
            {/* <Text style={tw`text-gray-400`}>Validez:</Text> */}

            <Text style={tw`text-gray-400 text-lg text-red-500`}>{guestPass.periodicity_str}</Text>

            {
              guestPass.periodicity == "one_time" &&
                <View style={tw`row gap-x-3`}>
                  <Text style={tw`text-gray-400 text-lg font-500`}>{entryDate.format('ddd D-MM-YYYY')}</Text>
                  
                  <Text style={tw`text-gray-400 text-lg font-500`}>{entryTime != "all_day" ? entryTime : "Todo el día"}</Text>
                </View>
            }

            {
              guestPass.periodicity == "recurrent" &&
              <View style={tw``}>
                <View style={tw`row`}>
                  <Text style={tw`text-gray-400`}>{entryDate.format('D/MMM/YYYY')} al {entryDateLimit.format('D/MMM/YYYY')}</Text>
                </View>

                <View style={tw`row justify-center`}>
                  {
                    entryTime == "all_day" ? 
                    <Text style={tw`text-gray-400 text-center`}>Todo el día</Text>
                    :
                        <Text style={tw`text-gray-400 text-center`}>De {entryTime} a {entryTimeLimit}</Text>
                  }
                </View>

                {renderDays()}
              </View>
            }
          </View>
        </View>

        <Text style={tw`text-white text-center text-xl font-500 mb-6 mt-6`}>Envía la invitación por mensaje para permitir el acceso</Text>

        {/* <Text>{JSON.stringify(guestPass)}</Text> */}
        <IconButton
          title={"Enviar pase"}
          style={tw`py-4`}
          color='secondary'
          icon={null}
          // onPress={sendGuestPass}
          // onPress={shareGuestPass}
          onPress={downloadAndShareImage}
        />

        <TouchableOpacity
          style={tw`py-4 items-center mt-4`}
          onPress={confirmDeletion}
          disabled={isDeleting}
        >
          <Text style={tw`text-secondary text-lg`}>
            {isDeleting ? 'Eliminando...' : 'Eliminar pase'}
          </Text>
        </TouchableOpacity>
      </ScrollView>

      
    </Modal>
  );
}
